import { FormService } from '../services/FormService';

export function useFormService(): FormService {
  return new FormService(useApiClient(), useUserStore());
}
